// Remove judge me link to same page
(() => {
  const PRODUCT_LINK_SELECTOR = 'a.jdgm-carousel-item__product[href]';

  const getHandle = (url) => {
    const match = /\/products\/([^/?#]+)/.exec(url || '');
    return match ? decodeURIComponent(match[1]).toLowerCase() : null;
  };

  const canonical = document.querySelector('link[rel="canonical"]');
  const currentHandle =
    getHandle(canonical && canonical.getAttribute('href')) || getHandle(window.location.pathname);

  if (!currentHandle) return;

  const unlinkSelfReviews = () => {
    document.querySelectorAll(PRODUCT_LINK_SELECTOR).forEach((link) => {
      if (getHandle(link.getAttribute('href')) !== currentHandle) return;

      const span = document.createElement('span');
      span.className = link.className;
      span.innerHTML = link.innerHTML;
      link.replaceWith(span);
    });
  };

  unlinkSelfReviews();

  // re-execute on re-renders.
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      unlinkSelfReviews();
    });
  });

  const wrappers = document.querySelectorAll('.jdgm-carousel-wrapper');
  const targets = wrappers.length ? wrappers : [document.body];

  targets.forEach((target) => {
    observer.observe(target, { childList: true, subtree: true });
  });
})();
